/**
 * @generated SignedSource<<0d29bc6424413b7e2c2b36640203dfff>>
 * @relayHash a610b905458276697a08cac8bbbcd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 790945dcea1def559514b63e007b4ef1b0eda94825738e19c758129607fba901

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type main_homeBroadcastDismiss_Mutation$variables = {
  cloudId: string;
  id: string;
};
export type main_homeBroadcastDismiss_Mutation$data = {
  readonly jira: {
    readonly setUserBroadcastMessageDismissed: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
      readonly userBroadcastMessage: {
        readonly id: string;
        readonly isDismissed: boolean | null | undefined;
        readonly shouldDisplay: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type main_homeBroadcastDismiss_Mutation = {
  response: main_homeBroadcastDismiss_Mutation$data;
  variables: main_homeBroadcastDismiss_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "concreteType": "JiraUserBroadcastMessage",
  "kind": "LinkedField",
  "name": "userBroadcastMessage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "shouldDisplay"
    },
    {
      "kind": "ScalarField",
      "name": "isDismissed"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_homeBroadcastDismiss_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUserBroadcastMessageActionPayload",
            "kind": "LinkedField",
            "name": "setUserBroadcastMessageDismissed",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_homeBroadcastDismiss_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUserBroadcastMessageActionPayload",
            "kind": "LinkedField",
            "name": "setUserBroadcastMessageDismissed",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "790945dcea1def559514b63e007b4ef1b0eda94825738e19c758129607fba901",
    "metadata": {},
    "name": "main_homeBroadcastDismiss_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f4b819af49c1e5fd15d1c6393f5cc1ca";

export default node;
